import React from "react";
import Dropzone from "react-dropzone";
import { cn } from "utils/helpers";
import { AllowedFileType } from "../types/AllowedFileType.types";
import { getFileMimeRecords } from "../utils";

interface DropzoneInputProps {
	accept?: AllowedFileType[];
	children?: React.ReactNode;
	description?: string;
	disabled?: boolean;
	maxFileSizeMB?: number;
	multiple?: boolean;
	onFilesAccepted: (files: File[]) => void;
}

/**
 * Provides a drag and drop to upload files
 * @param param0
 * @returns
 */
export const DropzoneInput: React.FC<DropzoneInputProps> = ({
	description = null,
	disabled = false,
	maxFileSizeMB,
	multiple = false,
	accept,
	onFilesAccepted,
	children,
}) => {
	const fileTypesLabel = accept
		? accept.map((type) => type.toUpperCase()).join(", ")
		: null;
	return (
		<Dropzone
			disabled={disabled}
			multiple={multiple}
			accept={getFileMimeRecords(accept)}
			onDrop={(acceptedFiles) => onFilesAccepted(acceptedFiles)}
		>
			{({ getRootProps, getInputProps, isDragActive }) => (
				<div
					{...getRootProps()}
					className={cn(
						"cursor-pointer rounded-lg border-2 border-dashed p-2 text-center",
						isDragActive && "border-utility-brand-600",
						disabled && "pointer-events-none opacity-50"
					)}
				>
					{children}
					<input {...getInputProps()} />
					{description && <p className="mb-2 text-sm">{description}</p>}
					<p className="text-sm">
						<span className="font-semibold text-royal-blue">
							Click to upload
						</span>{" "}
						or drag and drop
					</p>
					{fileTypesLabel && (
						<p className="mt-1 text-xs text-gray-500">
							{fileTypesLabel}
						</p>
					)}
					{maxFileSizeMB && (
						<p className="mt-1 text-xs text-gray-500">
							(Max file size {maxFileSizeMB}MB)
						</p>
					)}
				</div>
			)}
		</Dropzone>
	);
};
